import useDefinedContext from "hooks/useDefinedContext";
import YAxisStoreContext from "../contexts/YAxisStoreContext";

interface UseYAxisProps {}

function useYAxis(props?: UseYAxisProps) {
  return useDefinedContext(YAxisStoreContext);
}

export default useYAxis;
